import { render, staticRenderFns } from "./InputPhoneNumber.vue?vue&type=template&id=8d2b582e"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=js"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports